var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../layout.njk"] = require( "../layout.njk" );




var shim = require("D:/workspace/indivior-listmypractice-release/frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/views/pages/unsubscribe.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../layout.njk", true, "src/views/pages/unsubscribe.njk", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("meta_title"))(env, context, frame, runtime, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
output += t_4;
output += "\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("robots"))(env, context, frame, runtime, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
output += t_6;
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("body_class"))(env, context, frame, runtime, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
output += t_8;
output += "\r\n\r\n";
var t_10;
t_10 = true;
frame.set("showHCPHeader", t_10, true);
if(frame.topLevel) {
context.setVariable("showHCPHeader", t_10);
}
if(frame.topLevel) {
context.addExport("showHCPHeader", t_10);
}
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
output += t_11;
output += "\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_meta_title(env, context, frame, runtime, cb) {
var lineno = 2;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "Unsubscribe | List My Practice";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_robots(env, context, frame, runtime, cb) {
var lineno = 3;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "<meta name=\"robots\" content=\"noindex, nofollow\">";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_body_class(env, context, frame, runtime, cb) {
var lineno = 5;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "unsubscribe";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 9;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n<main id=\"main-content\">\r\n    <section>\r\n        <div class=\"container\">\r\n            <h1 class=\"mt-0\">Unsubscribe</h1>\r\n\r\n            <form action=\"/unsubscribe-confirmation\" class=\"unsubscribe-form\" id=\"unsubscribe-form\" method=\"post\" aria-label=\"Unsubscribe form\">\r\n                <div class=\"form-group\">\r\n                    <fieldset class=\"unsubscribe-fieldset\">\r\n                        <legend class=\"\"><strong>Please enter your email address and select which communications from Indivior you would like to unsubscribe from below.</strong></legend>\r\n\r\n                        <div class=\"row\">\r\n                            <div class=\"column mt-30\">\r\n                                <label id=\"email-label\" for=\"email\">Email Address\r\n                                <p class=\"form-error error-required hidden flex-vertical-center\">Please provide a valid email address.</p>\r\n                                </label>\r\n                                <input class=\"email\" id=\"email\" name=\"email\" placeholder=\"\" type=\"email\" value=\"\" aria-required=\"true\" maxlength=\"100\">\r\n                            </div>\r\n                        </div>\r\n                        <div id=\"unsubCheck-label\" class=\"mt-30\">\r\n                            <p class=\"form-error error-required hidden flex-vertical-center\">Please select at least one option to continue.</p>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                            <div class=\"column mt-20\">\r\n                                <input id=\"unsubscribe__content-lmp\" type=\"checkbox\" name=\"unsubCheck\" value=\"sourceFASTPpromotional\">\r\n                                <label class=\"radio-label text-left\" for=\"unsubscribe__content-lmp\">\r\n                                    <svg class=\"svg--icon-checkmark\">\r\n                                        <use xlink:href=\"#icon-checkmark\"></use>\r\n                                    </svg>\r\n                                    Unsubscribe from all communications about ListMyPractice.com and the Find a SUBLOCADE Treatment Provider Tool.\r\n                                </label>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                            <div class=\"column mt-10\">\r\n                                <input id=\"unsubscribe__content-sublocade\" type=\"checkbox\" name=\"unsubCheck\" value=\"sourceSubLocadepromotional\">\r\n                                <label class=\"radio-label text-left single-line\" for=\"unsubscribe__content-sublocade\">\r\n                                    <svg class=\"svg--icon-checkmark\">\r\n                                        <use xlink:href=\"#icon-checkmark\"></use>\r\n                                    </svg>\r\n                                    Unsubscribe from all promotional communications about SUBLOCADE.\r\n                                </label>\r\n                            </div>\r\n                        </div>\r\n                    </fieldset>\r\n                    <div class=\"row\">\r\n                        <div class=\"column mt-30\">\r\n                            <button type=\"submit\" class=\"btn btn-min-width btn-primary\" id=\"submit-unsubscribe\">\r\n                            <span class=\"btn-content\">Unsubscribe</span></button>\r\n                            <svg class=\"svg--icon-loading hidden\" id=\"unsubscribe-loading\">\r\n                                <use xlink:href=\"#icon-loading\"></use>\r\n                            </svg>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n      </div>\r\n    </section>\r\n</main>\r\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_meta_title: b_meta_title,
b_robots: b_robots,
b_body_class: b_body_class,
b_content: b_content,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/views/pages/unsubscribe.njk"] , dependencies)